/**
 * Run `worker` over `items` with at most `limit` in flight, preserving order.
 * Rejects with the first error; wrap the worker to opt into best-effort runs.
 */
export async function mapWithConcurrency<T, R>(
  items: readonly T[],
  limit: number,
  worker: (item: T, index: number) => Promise<R>
): Promise<R[]> {
  if (items.length === 0) return [];

  const width = Math.max(1, Math.min(Math.trunc(limit), items.length));
  const results = new Array<R>(items.length);
  let cursor = 0;

  const runners = Array.from({ length: width }, async () => {
    while (cursor < items.length) {
      const index = cursor;
      cursor += 1;
      results[index] = await worker(items[index], index);
    }
  });

  await Promise.all(runners);
  return results;
}
